// Mission « Super-Cerveau » — jeu coopératif enfant-parent (TDAH). FR uniquement.
export const SC_KEY = "m2hat_super_cerveau";

export const SC_COLORS = {
  pouvoir: { bg: "#FEF3C7", fg: "#B45309", ring: "#F59E0B" },
  obstacle: { bg: "#FFE4E6", fg: "#BE123C", ring: "#F43F5E" },
  boss: { bg: "#EDE9FE", fg: "#6D28D9", ring: "#8B5CF6" },
  arme: { bg: "#D1FAE5", fg: "#047857", ring: "#10B981" },
  mint: { bg: "#D1FAE5", fg: "#047857", ring: "#10B981" },
};

export const DEFAULT_LISTS = {
  pouvoirs: ["Planning", "Checklist", "Minuteur", "Calme", "Mouvement", "Pause", "Consigne courte", "Encouragement", "Préparation à l'avance", "Une seule chose à la fois"],
  obstacles: ["Bruit", "Fatigue", "Distraction", "Tâche trop longue", "Consigne compliquée", "Changement", "Attente", "Frustration", "Difficulté à commencer", "Trop de choses à faire"],
  boss: ["Impossible de commencer", "Grosse colère", "Abandon", "Conflit", "Refus massif", "Impossible de revenir à la tâche", "Désorganisation complète"],
  armes: ["Minuteur", "Planning", "Checklist", "Pause", "Mouvement", "Découpage de la tâche", "Consigne en une étape", "Choix entre deux possibilités", "Aide de l'adulte", "Environnement plus calme"],
};

export const DEFAULT_MOMENTS = [
  { id: "coucher", label: "Coucher (de la veille)", emoji: "🌙" },
  { id: "reveil", label: "Réveil", emoji: "⏰" },
  { id: "preparation", label: "Préparation", emoji: "🪥" },
  { id: "petitdej", label: "Petit-déjeuner", emoji: "🥣" },
  { id: "activites-matin", label: "Activités du matin (école, club…)", emoji: "🏫" },
  { id: "repas-midi", label: "Repas de midi", emoji: "🍽️" },
  { id: "activites-aprem", label: "Activités de l'après-midi (école, club…)", emoji: "⚽" },
  { id: "devoirs", label: "Devoirs", emoji: "📚" },
  { id: "repas-soir", label: "Repas du soir", emoji: "🍲" },
];

export const CARDS = [
  { id: "pouvoirs", title: "Super-pouvoir", sub: "Ce qui m'a aidé", img: "carte-super-pouvoir", color: "pouvoir", question: "Qu'est-ce qui a rendu ta mission plus facile aujourd'hui ?" },
  { id: "obstacles", title: "Petit obstacle", sub: "Ce qui m'a compliqué la mission", img: "carte-obstacle", color: "obstacle", question: "Qu'est-ce qui a rendu la mission plus difficile ?" },
  { id: "boss", title: "La montagne infranchissable", sub: "Ce qui m'a vraiment bloqué", img: "carte-montagne", color: "boss", question: "Quelle était ta montagne infranchissable aujourd'hui ? De quelle astuce aurais-tu eu besoin pour la franchir ?" },
  { id: "armes", title: "Nouvelle astuce", sub: "Une technique à tester", img: "carte-arme", color: "arme", question: "Demain, on teste… (une seule nouvelle astuce à la fois)" },
];

export const ENERGY = [
  { id: 3, label: "Super", emoji: "🔋", color: "#7CC6A6" },
  { id: 2, label: "Ça allait", emoji: "🙂", color: "#F2B84B" },
  { id: 1, label: "Compliqué", emoji: "😕", color: "#E0955C" },
  { id: 0, label: "Très compliqué", emoji: "🌧️", color: "#E0705C" },
];

export const DEFAULT_XP_ENFANT = [
  { id: "start", label: "J'ai commencé ma mission.", xp: 1 },
  { id: "check", label: "J'ai utilisé ma checklist.", xp: 1 },
  { id: "timer", label: "J'ai utilisé mon minuteur.", xp: 1 },
  { id: "aide", label: "J'ai demandé de l'aide correctement.", xp: 1 },
  { id: "pause", label: "J'ai fait une pause adaptée.", xp: 1 },
  { id: "retour", label: "Je suis revenu après ma pause.", xp: 1 },
  { id: "solution", label: "J'ai trouvé moi-même une solution.", xp: 1 },
  { id: "bloc", label: "J'ai identifié ce qui me bloquait.", xp: 1 },
  { id: "seul", label: "J'ai utilisé une stratégie sans que mon parent me le rappelle.", xp: 2 },
];

export const DEFAULT_XP_PARENT = [
  { id: "p-consigne", label: "J'ai donné une consigne courte.", xp: 1 },
  { id: "p-transition", label: "J'ai préparé une transition.", xp: 1 },
  { id: "p-repeter", label: "J'ai évité de répéter cinq fois.", xp: 1 },
  { id: "p-strategie", label: "J'ai renforcé une stratégie plutôt qu'un résultat.", xp: 1 },
  { id: "p-essayer", label: "J'ai laissé mon enfant essayer seul.", xp: 1 },
  { id: "p-calme", label: "J'ai gardé mon calme pendant un moment difficile.", xp: 1 },
];

export const DEFAULT_REWARDS = [
  { id: "r3", xp: 3, label: "Choisir la musique" },
  { id: "r5", xp: 5, label: "Choisir le jeu" },
  { id: "r7", xp: 7, label: "Choisir une activité avec papa/maman" },
  { id: "r10", xp: 10, label: "Activité spéciale" },
  { id: "r15", xp: 15, label: "Choisir une activité familiale" },
  { id: "r20", xp: 20, label: "Sortie ou activité choisie ensemble" },
];

// Renforcement négatif ludique : rappels parentaux à faire disparaître (défi Zéro rappel).
export const DEFAULT_RAPPELS = ["« Il faut commencer. »", "« Pense à ta checklist. »", "« Tu dois vraiment commencer. »", "« Allez, on y va. »"];

export const SECRET_POWERS = [
  { id: "start", name: "START", desc: "Je commence sans attendre." },
  { id: "check", name: "CHECK", desc: "Je vérifie ma checklist." },
  { id: "timer", name: "TIMER", desc: "J'utilise le minuteur." },
  { id: "pause", name: "PAUSE", desc: "Je sais faire une pause avant de saturer." },
  { id: "retour", name: "RETOUR", desc: "Je reviens à ma mission après la pause." },
  { id: "sos", name: "SOS", desc: "Je demande de l'aide avant que ça devienne un blocage." },
];

export const BADGES = ["Maître du démarrage", "Champion de la pause", "Détective des obstacles", "Expert du minuteur", "Roi/Reine de l'organisation", "Champion du retour à la mission", "Super-demandeur d'aide", "Maître de l'autonomie"];

export const XP_PER_LEVEL = 10;

export const LOOP = [
  { t: "Je cherche", d: "Ce qui m'aide, m'empêche, me bloque." },
  { t: "J'expérimente", d: "Une nouvelle stratégie." },
  { t: "Je gagne de l'XP", d: "Parce que j'utilise ma stratégie." },
  { t: "Je deviens plus autonome", d: "Mon parent intervient progressivement moins." },
  { t: "Je monte de niveau", d: "La stratégie devient une habitude." },
  { t: "Nouvelle mission", d: "Et on recommence." },
];

export const ROLES = [
  { r: "Le joueur", w: "l'enfant" },
  { r: "Le coéquipier", w: "le parent" },
  { r: "Le maître du jeu", w: "l'adulte, qui garantit les règles et valide les renforcements" },
  { r: "Objectif commun", w: "gagner en autonomie" },
];

export const MASTER_RULE = ["les règles", "les objectifs", "les critères pour gagner des XP", "les renforcements", "les récompenses", "les limites", "les ajustements nécessaires"];

export const LAB_QUESTION = "Quelle astuce ou technique a vraiment fonctionné ?";


export const CONTRACT_FIELDS = [
  { id: "mission", label: "Ma mission" },
  { id: "pouvoir", label: "Mon super-pouvoir" },
  { id: "outil", label: "Mon outil" },
  { id: "positif", label: "Mon renforcement positif" },
  { id: "negatif", label: "Mon renforcement négatif (rappel qui disparaît)" },
  { id: "recompense", label: "Ma récompense" },
  { id: "parent", label: "Mon parent s'engage à" },
];
